import React from 'react';
import { FormElement, Label } from '@dashboard/components/Form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@dashboard/components/ui/select';
import useTheme from '@dashboard/hooks/useTheme';
import { getThemeOptions } from '@dashboard/components/ThemeMenu';

const AppearanceForm = () => {
  const { theme, setTheme } = useTheme();

  return (
    <FormElement>
      <Label htmlFor="theme" description="Saved on this device only.">
        Theme
      </Label>
      <Select value={theme} onValueChange={setTheme}>
        <SelectTrigger id="theme" className="w-full sm:w-64">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {getThemeOptions().map(({ value, label }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormElement>
  );
};

export default AppearanceForm;
